export const STORAGE_KEYS = {
    FLIVE_TOKEN: "fliveToken",
    AUTH_TOKEN: "auth",
    CHILD_DATA: "child_data",
    DEFAULT_CHILD: "default_child",
    PARENT_DATA: "parent_data",
    SESSION_DATA: "session_data",
    FREADOM_CHILD_DATA: "freadom_child_data",
    REDUX_PERSIST: "persist:freadom",
    DEVICE_ID: "device_id",
    RECENT_SEARCH_DATA: "recent_search_data",
    APP_SESSION_ACTIVE: "app_session_active",
    SESSION_START: "sessionStart",
    MANUAL_SESSION_CONCLUDED: "MANUAL_SESSION_CONCLUDED",
    STORY_SECTION: "storySection",
    STORY_SOURCE_PAGE_ID: "storySourcePageId",
    STORY_ID_CONTEXT: "storyIdContext",
    ASSIGNMENT_POPUP: "assignment-popup",
    ATTENDANCE_POPUP: "attendance-popup",
    GP_POPUP: "gp-popup",
    VISITED: "visited",
    PROFILE_SELECTED: "profileSelected",
    IS_RELOADING: "is_reloading",
    AUTH: "auth",
    ROOM_NAME: "roomName",
    MEETING_ID: "meetingID",
    GRADE_ID: "grade_id",
    IRO_TEST_ID: "iro_test_id",
    IRO_TEST_NAME: "iro_test_name",
    IRO_AUTH_TOKEN: "auth_token",
    SAMPLE_ASSESSMENT_USER_NAME: "sample_assessment_user_name",
    SAMPLE_ASSESSMENT_USER_ID: "sample_assessment_user_id",
    FREADOM_ID: "freadom_id"
};
